import { q } from '../dom';

let timer: number | undefined;

export const toastTemplate = (): string => `<div class="toast" id="toast"></div>`;

export function toast(msg: string): void {
  const el = q('#toast');
  el.textContent = msg;
  el.classList.add('on');
  window.clearTimeout(timer);
  timer = window.setTimeout(() => el.classList.remove('on'), 2200);
}
